export default __webpack_public_path__ + "static/news-section-bar-image-637e5af95c2bf2f54cee4237ba7b4307.webp";